import React, {Suspense, useEffect, useState} from 'react';

import {auth} from './firebase';
import {Dialog, Snackbar, useMediaQuery} from '@material-ui/core';
import {useAuthState} from 'react-firebase-hooks/auth';
import {useHistory, useLocation} from 'react-router-dom';
import Alert from '@material-ui/lab/Alert';
const SignInInner = React.lazy(async () => {
  // await new Promise(resolve => setTimeout(resolve, 5000));
  return import('./SignInInner');
});

type Props = {
  showRequestCount: number;
};

const SignInUI: React.FC<Props> = props => {
  const history = useHistory();
  const location = useLocation();

  const isSigningIn = location.hash === '#signin';
  const [attempted, setAttempted] = useState(isSigningIn);
  const [show, setShow] = useState(isSigningIn);
  const [successOpen, setSuccessOpen] = React.useState(false);
  const isNarrow = useMediaQuery('(max-width: 20em)');

  useEffect(() => {
    if (props.showRequestCount) setShow(true);
  }, [props.showRequestCount]);

  const [user, loading, error] = useAuthState(auth as any);
  if (error) {
    console.log(error);
  }
  if (show && !loading) {
    if (isSigningIn) {
      if (user?.email) {
        setShow(false);
        history.replace('#');
      }
    } else {
      history.push('#signin');
    }
  }

  useEffect(() => {
    if (attempted && user?.email) {
      setSuccessOpen(true);
      setAttempted(false);
    }
  }, [attempted, user?.email]);

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason !== 'clickaway') {
      setSuccessOpen(false);
    }
  };

  const closeDialog = () => {
    history.replace('#');
    setShow(false);
  };
  return (
    <>
      <Dialog
        fullScreen={isNarrow}
        maxWidth="lg"
        open={show}
        onClose={closeDialog}
        PaperProps={{style: {padding: '1em'}}}
      >
        {' '}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            minWidth: '15em',
            minHeight: '15em',
            textAlign: 'center',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: '35em',
          }}
        >
          <Suspense fallback="Loading Secure Sign In...">
            <SignInInner closeDialog={closeDialog} />
          </Suspense>
        </div>
      </Dialog>
      <Snackbar
        open={successOpen}
        autoHideDuration={5000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity="success"
          style={{fontSize: 'large'}}
        >
          You have signed in successfully!
        </Alert>
      </Snackbar>
    </>
  );
};

export default SignInUI;
